import moment from "moment/moment";

export const getServiceRequestDate = (data) => {
  return moment(data.pendingDate).format("MM/DD/YYYY");
};
